import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "./assets/css/style.scss";
import "./assets/css/rtlStyle.scss";
import "./assets/css/responsive.scss";
import "./language/INEXT";
import { BrowserRouter as Router } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-lazy-load-image-component/src/effects/blur.css";
import { AuthProvider } from "./context/authContext";
import { UserProvider } from "./context/userContext";
import { PermissionProvider } from "./context/permissionsContext";
import { Provider } from "react-redux";
import { store } from "./store";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <Router>
      <AuthProvider>
        <UserProvider>
          <PermissionProvider>
            <App />
          </PermissionProvider>
        </UserProvider>
      </AuthProvider>
    </Router>
  </Provider>
);

reportWebVitals();
